/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VaultTag
 */
export interface VaultTag {
    /**
     * 
     * @type {string}
     * @memberof VaultTag
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof VaultTag
     */
    category: string;
    /**
     * 
     * @type {string}
     * @memberof VaultTag
     */
    term: string;
}

export function VaultTagFromJSON(json: any): VaultTag {
    return VaultTagFromJSONTyped(json, false);
}

export function VaultTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): VaultTag {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'category': json['category'],
        'term': json['term'],
    };
}

export function VaultTagToJSON(value?: VaultTag | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'category': value.category,
        'term': value.term,
    };
}


